import stylex from '@stylexjs/stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';

export const styles = stylex.create({
  sections: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: anatomy['space-12'],
    alignSelf: 'flex-start',
    width: '100%',
  },
  section: {
    display: 'flex',
    padding: '16px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '2px',
    alignSelf: 'flex-start',
    width: '859px',
    border: `1px solid ${colors.tertiaryBorder}`,
    borderRadius: anatomy.borderRadiusS,
    backgroundColor: colors.ghostBackground,
  },
  sectionTitle: {
    color: colors.primaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeBody-5'],
    fontWeight: typography.fontWeighDemi,
    lineHeight: typography['fontSizeHeading-4'],
    margin: 0,
  },
  mainGuestSectionTitle: {
    color: colors.secondaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-2'],
    fontStyle: 'normal',
    lineHeight: typography['lineHeightCaption-2'],
  },
  mainGuestBlock: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: anatomy['space-8'],
    width: '100%',
  },
  sectionExtraGuests: {
    gap: anatomy['space-8'],
  },
  extraGuestsContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',

    gap: anatomy['space-20'],
    alignSelf: 'stretch',
    width: '100%',
  },
  extraGuestsContentNoGap: {
    gap: anatomy.spaceNo,
  },
  addGuestButtons: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: anatomy['space-16'],
    alignSelf: 'flex-start',
  },
  adultContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: anatomy['space-20'],
    alignSelf: 'stretch',
    fontFamily: fonts.din2014Regular,
  },
});
